<template>
  <div>
    <h2 class="text-center mt-0 pt-4" style="border-bottom: 2px solid;">Gallery</h2>
    <!--Slider-->
    <div style="background: rgb(214 243 219)">
      <h3 class="pl-3 mt-4">Slider Image</h3>
      <div class="row">
        <div v-for="(item,i) in sliderImages"
            :key="i"
            class="col-md-3 text-center my-2">
          <img :src="item.url" width="300" alt="Image" class="header-image">
          <i v-if="item.publicId" class="fa fa-times position-absolute header-delete"
            @click="() => deleteImage('sliderImage', item.publicId)" aria-hidden="true"></i>
        </div>
        <div class="col-md-12">
          <form @submit.prevent="uploadSliderImage">
            <div class="row">
              <div class="col-md-2 text-center">
                <img :src="sliderPreview" alt="" width="150">
              </div>
              <div class="col-md-2 p-4">
                <img src="/img/upload.png" alt=""> Upload New Image
                <input type="file" @change="sliderImageSelected" accept="image/*" class="uploadBtn"/>
              </div>
              <div class="col-md-4 text-left p-4 contentBtnAlign">
                <button class="btn submitBtn">Upload</button>
                <img v-if="showSliderLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--Restaurant-->
    <div style="background: rgb(224 208 222)">
      <h3 class="pl-3 mt-4">Restaurant Image</h3>
      <div class="row px-2">
      <div v-for="(item,i) in restaurantImages"
          :key="i"
          class="col-md-3 text-center my-2">
        <img :src="item.url" width="100%" alt="Image" class="header-image">
        <i v-if="item.publicId" class="fa fa-times position-absolute header-delete text-right"
          @click="() => deleteImage('restaurantImage', item.publicId)" aria-hidden="true"></i>
      </div>
      <div class="col-md-12">
        <form @submit.prevent="uploadRestaurantImage">
          <div class="row">
            <div class="col-md-2 text-center">
              <img :src="restaurantPreview" alt="" width="150">
            </div>
            <div class="col-md-2 p-4">
              <img src="/img/upload.png" alt=""> Upload New Image
              <input type="file" @change="restaurantImageSelected" accept="image/*" class="uploadBtn"/>
            </div>
            <div class="col-md-4 text-left p-4 contentBtnAlign">
              <button class="btn submitBtn">Upload</button>
              <img v-if="showRestaurantLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
            </div>
          </div>
        </form>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['requestHeader'],
  data() {
    return {
      sliderImages: [],
      slider: {image: null},
      sliderPreview: null,
      showSliderLoading: false,
      restaurantImages: [],
      restaurant: {image: null},
      restaurantPreview: null,
      showRestaurantLoading: false,
    }
  },
  mounted() {
    this.getAllImages()
  },
  methods: {
    getAllImages(){
      let url = process.env.VUE_APP_API_URL+'/api/gallery?restaurantId='+localStorage.getItem('restaurantId')

      axios
        .get(url, {
          headers: this.requestHeader
        })
        .then((data) => {
          this.sliderImages = data.data.sliderImages
          this.restaurantImages = data.data.restaurantImages
        })
    },
    sliderImageSelected(e){
      const file = e.target.files[0]
      if (file) {
        this.slider.image = file;
        this.sliderPreview = URL.createObjectURL(file);
      }
    },
    restaurantImageSelected(e){
      const file = e.target.files[0]
      if (file) {
        this.restaurant.image = file;
        this.restaurantPreview = URL.createObjectURL(file);
      }
    },
    uploadSliderImage() {
      if (!this.slider.image) return
      this.showSliderLoading = true
      const dataToSubmit = new FormData()
      dataToSubmit.append('file', this.slider.image || '')
      dataToSubmit.append('restaurantId', localStorage.getItem('restaurantId') || '')
      let url = process.env.VUE_APP_API_URL+'/api/gallery/uploadSliderImage'

      axios
        .post(url, dataToSubmit, {
          headers: this.requestHeader
        })
        .then((data) => {
          if (data.status == 200) {
            this.showSliderLoading = false
            this.$toastr.s("Successfully Created.", "Success");
            setTimeout(()=> {this.$router.go()}, 1000)
          }
        }).catch((error) => {
          this.showSliderLoading = false
          this.$toastr.w(error.response.data.message, "Warning");
        })
    },
    uploadRestaurantImage() {
      if (!this.restaurant.image) return
      this.showRestaurantLoading = true
      const dataToSubmit = new FormData()
      dataToSubmit.append('file', this.restaurant.image || '')
      dataToSubmit.append('restaurantId', localStorage.getItem('restaurantId') || '')
      let url = process.env.VUE_APP_API_URL+'/api/gallery/uploadRestaurantImage'

      axios
        .post(url, dataToSubmit, {
          headers: this.requestHeader
        })
        .then((data) => {
          if (data.status == 200) {
            this.showRestaurantLoading = false
            this.$toastr.s("Successfully Created.", "Success");
            setTimeout(()=> {this.$router.go()}, 1000)
          }
        }).catch((error) => {
          this.showRestaurantLoading = false
          this.$toastr.w(error.response.data.message, "Warning");
        })
    },
    deleteImage(type, publicId){
      if (confirm('Please confirm to delete.')){
        let url = ''
        if(type == 'sliderImage'){
          url = process.env.VUE_APP_API_URL+`/api/gallery/deleteSliderImage?restaurantId=${localStorage.getItem('restaurantId')}&publicId=${publicId}`
        }else{
          url = process.env.VUE_APP_API_URL+`/api/gallery/deleteRestaurantImage?restaurantId=${localStorage.getItem('restaurantId')}&publicId=${publicId}`
        }

        axios
          .post(url, {},{
            headers: this.requestHeader
          })
          .then((data) => {
            if (data.status == 200) {
              this.$toastr.s("Successfully Deleted.", "Success");
              setTimeout(()=> {this.$router.go()}, 1000)
            }
          })
      }
    },
  }
}
</script>

<style scoped>
.uploadBtn {
  cursor: pointer;
  position: absolute;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.submitBtn {
  background-color: #E317E3;
  color: white;
  border-color:  #E317E3;
}
.header-delete{width: 40px; height:40px; top: 0; cursor:pointer; font-size: 1.5rem;right: 35px; color: red;}

</style>
